



















import Vue from "vue";
import { IKeyword } from "../store/state";

interface KeywordItemProps {
  name: string;
  item: IKeyword;
  checked: string[];
  disabled: boolean;
}

interface KeywordItemComputed {
  itemFor: string;
  focusedClass: any;
}

interface KeywordItemMethods {
  change(e: Event): void;
}

interface KeywordItemData {
  focused: boolean;
}

export default Vue.extend<
  KeywordItemData,
  KeywordItemMethods,
  KeywordItemComputed,
  KeywordItemProps
>({
  name: "KeywordItem",
  model: {
    prop: "checked",
    event: "change"
  },
  props: {
    name: String,
    item: Object,
    checked: Array,
    disabled: Boolean
  },
  data() {
    return {
      focused: false
    };
  },
  computed: {
    itemFor() {
      return this.item.id.replace(".", "");
    },
    focusedClass() {
      return {
        "sh-form__checkbox-focused": this.focused
      };
    }
  },
  methods: {
    change(e: any) {
      if (e.target.checked) {
        this.$emit("change", [...this.checked, e.target.value]);
      } else {
        this.$emit(
          "change",
          this.checked.filter(c => e.target.value !== c)
        );
      }
    }
  }
});
